import React from "react";
import styled from "styled-components";
import { breakpoints } from "../style/theme";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 0 0 0 0;
  @media screen and (max-width: ${(props) => props.breakpoints - 1}px) {
    margin: 0 0 0 0;
  }
`

const Title = styled.h2`
  position: relative;
  margin: 0;
  padding: 0;
  font-size: 2.0rem;
  letter-spacing: 0.13em;
  font-weight: bold;
  text-align: center;
  font-family: 'Montserrat', serif;
  color: ${props => props.color};
  @media screen and (max-width: ${(props) => props.breakpoints - 1}px) {
    font-size: 1.6rem;
  }
`

const Small = styled.span`
  position: relative;
  margin: 0;
  padding: 0;
  font-size: 0.9rem;
  letter-spacing: 0.13em;
  font-weight: normal;
  text-align: center;
  color: ${props => props.color};
  @media screen and (max-width: ${(props) => props.breakpoints - 1}px) {
    //font-size: 1.0rem;
  }
`

export const ProductSubTitle = ({title, small, color, breakpoints}) => {
  return (
    <Wrapper breakpoints={breakpoints}>
      <Title color={color} breakpoints={breakpoints}>{title}</Title>
      <Small color={color} breakpoints={breakpoints}>{small}</Small>
    </Wrapper>
  )
}